import { render } from "./crm.vue?vue&type=template&id=39659138&scoped=true"
import script from "./crm.js?vue&type=script&lang=js"
export * from "./crm.js?vue&type=script&lang=js"

import "./crm.vue?vue&type=style&index=0&id=39659138&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39659138"]])

export default __exports__